var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#142b6f","strokeWidth":"2","transform":"translate(1 1)"},[React.createElement("path",{"d":"m1 11h12v1h-12z","fillRule":"nonzero","key":0}),React.createElement("path",{"d":"m10-4-6 7 6 7","transform":"matrix(0 -1 -1 0 10 10)","key":1})]));
}

IconDownload.defaultProps = {"height":"13","viewBox":"0 0 16 13","width":"16"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
